import { useEffect, useState } from "react";
import UserFilters from "../UserFilters.jsx";
import { getNgoList } from "../../../api/users.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Heading from "../../../components/Heading.jsx";
import NgoTable from "../NgoTable.jsx";

function NGOList() {
    
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);

    const genderFilters = [
        { value: 'male', placeholder: 'Male', },
        { value: 'female', placeholder: 'Female', },
        { value: 'other', placeholder: 'Other', }
    ];
    const ageGroupFilters = [
        { value: 'kid', placeholder: 'Kid' },
        { value: 'adult', placeholder: 'Adult' },
        { value: 'old', placeholder: 'Old' },
    ];
    const userActiveFilters = [
        { value: true, placeholder: 'Active' },
        { value: false, placeholder: 'Inactive' },
    ];
      
    const engagementTypes = [
        { value: 'Tree Planting', placeholder: 'Tree Planting' },
        { value: 'Food Distribution', placeholder: 'Food Distribution' },
        { value: 'Event Promotion', placeholder: 'Event Promotion' },
    ];

    const [filters, setFilters] = useState([
        { label: 'NGO Name', placeholder: 'Enter NGO Name', name: 'name', value: '', type: 'text' },
        { label: 'Email', placeholder: 'Enter Email', name: 'email', value: '', type: 'email' },
        { 
            label: 'Type of Engagement', 
            placeholder: 'Select Type of Engagement', 
            name: 'typesOfEngagement', 
            value: '', 
            type: 'select',
            data: engagementTypes 
        },
        { 
            label: 'Status', 
            placeholder: 'Select Status', 
            name: 'active', 
            value: '', 
            type: 'select',
            data: [
                { value: true, placeholder: 'Active' },
                { value: false, placeholder: 'Inactive' }
            ]
        },
    ]);

    const filterUsers = () => {
        const activeFilters = filters.filter(f => f.value !== '');
        
        if (activeFilters.length === 0) {
            setFilteredUsers(users);
            return;
        }

        const result = users.filter(user => {
            return activeFilters.every(filter => {
                const filterValue = filter.value;
                
                // Handle nested properties (e.g., partnershipDetails.typeOfEngagement)
                const fieldPath = filter.name.split('.');
                let userValue = user;
                for (const key of fieldPath) {
                    userValue = userValue?.[key];
                }
                
                // Handle text fields with case-insensitive partial matching
                if (filter.type === 'text' || filter.type === 'email') {
                    return userValue && String(userValue).toLowerCase().includes(String(filterValue).toLowerCase());
                }
                
                // Handle select fields
                if (filter.type === 'select') {
                    if (Array.isArray(userValue)) {
                        return userValue.some(v => String(v).toLowerCase() === String(filterValue).toLowerCase());
                    }
                    return String(userValue).toLowerCase() === String(filterValue).toLowerCase();
                }
                
                return true;
            });
        });
        
        setFilteredUsers(result);
    };

    const clearFilters = () => {
        const resetFilters = filters.map(filter => ({ ...filter, value: '' }));
        setFilters(resetFilters);
        setFilteredUsers(users);
    }
    
    useEffect(() => {
        // Fetch list from server. Pass current filters so server can pre-filter if desired.
        getNgoList((data) => {
            // Extract ngos array from pagination response
            const ngosArray = data?.ngos || [];

            const getTimestamp = (user) => {
                if (user?.createdAt) {
                    const d = new Date(user.createdAt);
                    return isNaN(d.getTime()) ? 0 : d.getTime();
                }
                if (user?._id) {
                    try {
                        const sec = parseInt(user._id.toString().substring(0, 8), 16);
                        return sec * 1000;
                    } catch (err) {
                        return 0;
                    }
                }
                return 0;
            };
            const sorted = ngosArray.slice().sort((a, b) => getTimestamp(b) - getTimestamp(a));
            setUsers(sorted);
            setFilteredUsers(sorted);
        }, toast, // send only non-empty filters to backend
        filters.reduce((acc, f) => {
            if (f.value !== undefined && f.value !== null && String(f.value).trim() !== '') acc[f.name] = f.value;
            return acc;
        }, {}));
    }, []);
    
    return (
        <main className="flex flex-col text-sm font-semibold text-gray-900 rounded-none">
            <Heading
                text={"All NGOs"}
            />
            <UserFilters
                filters={filters}
                setFilters={setFilters}
                filterUsers={filterUsers}
                clearFilters={clearFilters}
            />
            <section className="flex flex-col pt-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                    <h1 className="self-start text-base font-semibold">NGO Data List</h1>
                    <NgoTable users={filteredUsers} toast={toast} />
                </div>
            </section>
            <ToastContainer 
                position = "top-right"
                autoClose={1000}
            />
        </main>
    );
}

export default NGOList;